import { useEffect, useMemo, useState } from 'react'
import { listMyEstates } from 'services/estateService'
import { PillSelect } from './FilterControls'

const MAX_PAGES = 10

const loadAllEstates = async () => {
  const all = []
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const res = await listMyEstates(page)
    all.push(...(res?.data?.data || []))
    const lastPage = res?.data?.meta?.lastPage || 1
    if (page >= lastPage) break
  }
  return all
}

const EstateFilter = ({ value, onChange }) => {
  const [estates, setEstates] = useState([])

  useEffect(() => {
    let cancelled = false
    loadAllEstates()
      .then(list => { if (!cancelled) setEstates(list) })
      .catch(() => { if (!cancelled) setEstates([]) })
    return () => { cancelled = true }
  }, [])

  const options = useMemo(() => {
    const list = estates
      .map(estate => ({ value: estate.id, label: estate.name || 'Unnamed estate' }))
      .sort((a, b) => a.label.localeCompare(b.label))
    if (value && !list.some(option => option.value === value)) list.unshift({ value, label: 'Chosen estate' })
    return list
  }, [estates, value])

  if (!options.length) return null

  return (
    <PillSelect
      $active={!!value}
      value={value}
      onChange={next => onChange(next || null)}
      options={options}
      clearable
      clearLabel='All estates'
      placeholder='Estate'
      searchPlaceholder='Search estates'
      ariaLabel='Show remedials for one estate'
    />
  )
}

export default EstateFilter
